import { QueryProps } from '../shared/shared.type'
export type QueryPropsLogs = QueryProps & {
  module?: string
  adminId?: string
  adminRole?: string
}

export type IData = {
  _id: string
  adminId: string
  adminName: string
  adminEmail: string
  adminRole: string
  module: string
  action: string
  description: string
  targetEntity: string
  targetEntityId: string
  changes: []
  ipAddress: string
  userAgent: string
  metadata: {
    status: string
  }
  createdAt: string
  updatedAt: string
}

export type AuditLogsResponse = {
  data: {
    result: IData[]
    count: number
  }
  success: boolean
  message: string
}

export enum AdminModule {
  DASHBOARD = 'DASHBOARD',
  GOOD_HOME = 'GOOD_HOME',
  PRODUCT = 'PRODUCT',
  EVENTS = 'EVENTS',
  ORDERS = 'ORDERS',
  CREATORS = 'VENDORS',
  FULFILLMENT_CENTER = 'FULFILLMENT_CENTER',
  AFFILIATES = 'AFFILIATES',
  AMBASSADORS = 'AMBASSADORS',
  FINANCE = 'FINANCE',
  SETTINGS = 'SETTINGS',
  CATEGORIES = 'CATEGORIES',
  SUBCATEGORIES = 'SUBCATEGORIES',
  CUSTOMERS = 'CUSTOMERS',
  ARTICLES = 'ARTICLES',
  DISCOUNTS = 'DISCOUNTS',
  LOCATIONS = 'LOCATIONS',
  LISTS = 'LISTS',
  TEAMS = 'TEAMS',
  REPORTS = 'REPORTS',
  VOUCHERS = 'VOUCHERS',
  POS = 'POS',
  REFERRAL_REWARDS = 'REFERRAL_REWARDS',
  REFUNDS = 'REFUNDS',
  ROLES = 'ROLES',
  PERMISSIONS = 'PERMISSIONS',
  WALLETS = 'WALLETS',
  SETTLEMENTS = 'SETTLEMENTS',
  FEES = 'FEES',
  SHOPPING_INTERESTS = 'INTERESTS',
}
